import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * LinkedInRouteTracker — fires a fresh LinkedIn Insight page-view on
 * every client-side route change.
 *
 * WHY: the base tag in public/index.html initialises ONCE on the first
 * page load. Because this app uses React Router (client-side navigation),
 * subsequent route changes (e.g. /login → /dashboard, / → /register)
 * do NOT trigger a full page load, so the tag never sends a fresh URL
 * to LinkedIn. LinkedIn's Campaign Manager therefore never sees the
 * user visit /dashboard and the "URL contains /dashboard" conversion
 * rule silently fails.
 *
 * FIX: on every location change we call window.lintrk("track") which
 * re-reads window.location.href and pushes a new collect event to
 * LinkedIn with the CURRENT URL — exactly what a full page reload
 * would do. Guarded with a typeof check so pre-render / SSR / tag-
 * disabled environments never throw.
 *
 * Mount ONCE inside the router, at the top of the app tree.
 * Feb 2026 — LinkedIn ad tracking wire-up.
 */
export default function LinkedInRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (typeof window.lintrk !== "function") return;
    try {
      window.lintrk("track");
    } catch (_) {
      /* never break the app for an analytics ping */
    }
  }, [location.pathname, location.search]);

  return null;
}
